export const mappedNAICS = [
  {
    code: '518210',
    description:
      'Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services',
  },
  { code: '541330', description: 'Engineering Services' },
  { code: '541380', description: 'Testing Laboratories and Services' },
  { code: '541511', description: 'Custom Computer Programming Services' },
  { code: '541512', description: 'Computer Systems Design Services' },
  { code: '541513', description: 'Computer Facilities Management Services' },
  { code: '541519', description: 'Other Computer Related Services' },
  {
    code: '541613',
    description:
      'Process, Physical Distribution, and Logistics Consulting Services',
  },
  {
    code: '541690',
    description: 'Other Scientific and Technical Consulting Services',
  },
  { code: '541713', description: 'Research and Development in Nanotechnology' },
  {
    code: '541714',
    description:
      'Research and Development in Biotechnology (except Nanobiotechnology)',
  },
  {
    code: '541715',
    description:
      'Research and Development in the Physical, Engineering, and Life Sciences (except Nanotechnology and Biotechnology)',
  },
  {
    code: '541720',
    description:
      'Research and Development in the Social Sciences and Humanities',
  },
  { code: '561621', description: 'Security Systems Services' },
  { code: '611420', description: 'Computer Training' },
  {
    code: '611430',
    description: 'Professional and Management Development Training',
  },
  { code: '611519', description: 'Other Technical and Trade Schools' },
  {
    code: '611699',
    description: 'All Other Miscellaneous Schools and Instruction',
  },
  { code: '611710', description: 'Educational Support Services' },
  {
    code: '621999',
    description: 'All Other Miscellaneous Ambulatory Health Care Services',
  },
];
